// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.building-modal {
  width: 600px;
  max-width: 95vw;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 16px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  overflow: hidden;
}

.building-form {
  padding: 32px;
  background: white;
}

.form-group {
  margin-bottom: 28px;
  position: relative;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #1f2937;
  font-size: 15px;
  letter-spacing: -0.025em;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 16px 20px;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  font-size: 16px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  background-color: #ffffff;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-sizing: border-box;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
  background-color: #fefefe;
  transform: translateY(-1px);
}

.form-group input::placeholder,
.form-group textarea::placeholder {
  color: #9ca3af;
  font-weight: 400;
}

.form-group textarea {
  resize: vertical;
  min-height: 100px;
  line-height: 1.6;
}

.error-message {
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  color: #dc2626;
  padding: 16px 20px;
  border-radius: 12px;
  margin-bottom: 24px;
  border: 1px solid #fecaca;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
}

.error-message::before {
  content: "⚠️";
  font-size: 18px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 40px;
  padding-top: 32px;
  border-top: 2px solid #f1f5f9;
}

.cancel-button,
.save-button {
  padding: 14px 28px;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  letter-spacing: -0.025em;
  min-width: 120px;
}

.cancel-button {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  color: #475569;
  border: 2px solid #e2e8f0;
}

.cancel-button:hover {
  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);
  border-color: #cbd5e1;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px -8px rgba(71, 85, 105, 0.3);
}

.save-button {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  color: white;
  box-shadow: 0 4px 14px 0 rgba(59, 130, 246, 0.4);
}

.save-button:hover:not(:disabled) {
  background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px -8px rgba(59, 130, 246, 0.5);
}

.save-button:disabled {
  background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%);
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* Modal overlay and content styles (if not already defined) */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.6) 100%);
  backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.modal-content {
  background: white;
  border-radius: 16px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  animation: slideUp 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Modal header styling */
.modal-header {
  padding: 24px 32px 16px;
  border-bottom: 2px solid #f1f5f9;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  color: #1f2937;
  letter-spacing: -0.025em;
}

.modal-content {
  max-height: 90vh;
  overflow-y: auto;
}

.close-button {
  background: none;
  border: none;
  font-size: 28px;
  cursor: pointer;
  color: #6b7280;
  padding: 8px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.close-button:hover {
  background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
  color: #374151;
  transform: scale(1.05);
}`, "",{"version":3,"sources":["webpack://./src/components/BuildingModal.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,eAAe;EACf,6DAA6D;EAC7D,mBAAmB;EACnB,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,wBAAwB;AAC1B;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,8EAA8E;EAC9E,yBAAyB;EACzB,iDAAiD;EACjD,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;EAC7C,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,gDAAgD;AAClD;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,mDAAmD;AACrD;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,8DAA8D;AAC9D;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mFAAmF;EACnF,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iDAAiD;EACjD,oDAAoD;AACtD;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,yBAAyB;AACzB;EACE,uBAAuB;EACvB,gCAAgC;EAChC,6DAA6D;EAC7D,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,sBAAsB;AACxB","sourcesContent":[".building-modal {\n  width: 600px;\n  max-width: 95vw;\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  border-radius: 16px;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  overflow: hidden;\n}\n\n.building-form {\n  padding: 32px;\n  background: white;\n}\n\n.form-group {\n  margin-bottom: 28px;\n  position: relative;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: #1f2937;\n  font-size: 15px;\n  letter-spacing: -0.025em;\n}\n\n.form-group input,\n.form-group textarea {\n  width: 100%;\n  padding: 16px 20px;\n  border: 2px solid #e5e7eb;\n  border-radius: 12px;\n  font-size: 16px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  background-color: #ffffff;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-sizing: border-box;\n}\n\n.form-group input:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);\n  background-color: #fefefe;\n  transform: translateY(-1px);\n}\n\n.form-group input::placeholder,\n.form-group textarea::placeholder {\n  color: #9ca3af;\n  font-weight: 400;\n}\n\n.form-group textarea {\n  resize: vertical;\n  min-height: 100px;\n  line-height: 1.6;\n}\n\n.error-message {\n  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);\n  color: #dc2626;\n  padding: 16px 20px;\n  border-radius: 12px;\n  margin-bottom: 24px;\n  border: 1px solid #fecaca;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.error-message::before {\n  content: \"⚠️\";\n  font-size: 18px;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 16px;\n  margin-top: 40px;\n  padding-top: 32px;\n  border-top: 2px solid #f1f5f9;\n}\n\n.cancel-button,\n.save-button {\n  padding: 14px 28px;\n  border: none;\n  border-radius: 12px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  letter-spacing: -0.025em;\n  min-width: 120px;\n}\n\n.cancel-button {\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n  color: #475569;\n  border: 2px solid #e2e8f0;\n}\n\n.cancel-button:hover {\n  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);\n  border-color: #cbd5e1;\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px -8px rgba(71, 85, 105, 0.3);\n}\n\n.save-button {\n  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);\n  color: white;\n  box-shadow: 0 4px 14px 0 rgba(59, 130, 246, 0.4);\n}\n\n.save-button:hover:not(:disabled) {\n  background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px -8px rgba(59, 130, 246, 0.5);\n}\n\n.save-button:disabled {\n  background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%);\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n/* Modal overlay and content styles (if not already defined) */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(135deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.6) 100%);\n  backdrop-filter: blur(8px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  animation: fadeIn 0.3s ease-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.modal-content {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  animation: slideUp 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n/* Modal header styling */\n.modal-header {\n  padding: 24px 32px 16px;\n  border-bottom: 2px solid #f1f5f9;\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.modal-header h2 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n  color: #1f2937;\n  letter-spacing: -0.025em;\n}\n\n.modal-content {\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.close-button {\n  background: none;\n  border: none;\n  font-size: 28px;\n  cursor: pointer;\n  color: #6b7280;\n  padding: 8px;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 12px;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.close-button:hover {\n  background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);\n  color: #374151;\n  transform: scale(1.05);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
